export const print = (target, iframe) => {
    const content = document.getElementById(target);
    const pri = document.getElementById(iframe).contentWindow;
    pri.document.open();
    pri.document.write(content.innerHTML);
    pri.document.close();
    pri.focus();
    pri.print();
  }